/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { SpinnerComponent } from "../../../spinner/spinner.component";
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { NgClass } from "@angular/common";

@Component({
	selector: "globalictcc-loading-overlay",
	standalone: true,
	imports: [SpinnerComponent, NgClass],
	templateUrl: "./loading-overlay.component.html",
	styleUrl: "./loading-overlay.component.scss"
})
export class LoadingOverlayComponent implements ILoadingOverlayAngularComp {
	public agInit() {}
}
